export class Constants {
  static ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
  static ROLE_KEY = 'ROLE';
  static REFRESH_TOKEN_KEY = 'REFRESH_TOKEN';
}
